export const EDIT_COORDINATES_ZONE = 'EDIT_COORDINATES_ZONE'
export const EDIT_COORDINATES_ZONE_MULTIPLE = 'EDIT_COORDINATES_ZONE_MULTIPLE'
export const INSERT_ZONE = 'INSERT_ZONE'
export const DELETE_ZONE = 'DELETE_ZONE'
export const INSERT_ZONE_INFO = 'INSERT_ZONE_INFO'
export const DELETE_ZONE_INFO = 'DELETE_ZONE_INFO'
export const EDIT_ZONE_INFO = 'EDIT_ZONE_INFO'
export const CHANGE_ZONE_ID = 'CHANGE_ZONE_ID'
